import { TypedObject } from '@/definitions';
import { Component, Vue } from 'vue-property-decorator';

import Modal from '@/components/modal';
import Alert from '@/components/alert';
import NavBar from '@/components/navbar';
import template from './app.vue';

@Component({
  mixins: [template],
  components: {
    NavBar,
    Modal,
    Alert
  }
})
export default class App extends Vue {
  get modalActive(): boolean {
    return !!this.$Store.getters.MODAL_ACTIVE;
  }

  get hasNav(): boolean {
    return !(this.$route.meta.hideNav);
  }

  get appAdmin(): boolean {
    return this.$Store.state.user.isAppAdmin;
  }

  get info(): TypedObject {
    const date = new Date();
    return {
      now:       String(date.getFullYear()),
      version:   this.$package.version,
      title:     this.$package.title,
      publisher: this.$package.publisher,
      homepage:  this.$package.homepage,
    };
  }
}